import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '⏱️',
    title: 'pages.quizOnboarding.dailyGoal.answer1',
    value: '3_min',
  },
  {
    emoji: '⏰',
    title: 'pages.quizOnboarding.dailyGoal.answer2',
    value: '5_min',
  },
  {
    emoji: '🕒',
    title: 'pages.quizOnboarding.dailyGoal.answer3',
    value: '10_min',
  },
  {
    emoji: '🔥',
    title: 'pages.quizOnboarding.dailyGoal.answer4',
    value: '15_min',
  },
]

export default function DailyGoalPage() {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const selected = event.currentTarget.value as string
    if (selected) localStorage.setItem('quizDailyGoal', selected)
  }

  return (
    <QuizChoicePage
      answers={answers}
      onSubmit={handleSubmit}
      title="pages.quizOnboarding.dailyGoal.title"
    />
  )
}
